<template>
    <div class="restaurant-map">
        <base-map
            :center="{ lat, lng }"
            :center-marker-icon="mapCenterMarker"
        />

        <div class="directions">
            <b-button
                variant="primary"
                :href="directionsLink"
                target="_blank"
                rel="noopener"
                v-test:getDirectionsButton
            >
                {{ $snippet('get_directions', 'get directions') }}
            </b-button>
        </div>
    </div>
</template>

<script>
    import BaseMap from '../../molecules/BaseMap/BaseMap';

    export default {
        name: 'restaurant-map',

        components: { BaseMap },

        props: {
            lat: {
                type: [String, Number],
                required: true,
            },

            lng: {
                type: [String, Number],
                required: true,
            },

            address: {
                type: String,
                required: true,
            },
        },

        computed: {
            /**
             * Return the center map marker icon.
             *
             * @returns {string}
             */
            mapCenterMarker() {
                return require('../../../assets/icons/svgs/map-marker.svg');
            },

            /**
             * Return the link for the directions button.
             *
             * We will link off to google maps with the restaurant location prefilled.
             *
             * @returns {string}
             */
            directionsLink() {
                return `https://www.google.co.uk/maps/dir/${ this.address.replace(/ /g, '+') }/@${ this.lat },${ this.lng },17z`;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .restaurant-map {
        position: relative;
    }

    .base-map ::v-deep {
        .map-container {
            @include media-breakpoint-up(md) {
                padding-bottom: percentage(464 / 528);
            }
        }
    }

    .directions {
        position: absolute;
        bottom: 40px;
        left: 50%;
        transform: translateX(-50%);

        .btn {
            padding-left: rem(30px);
            padding-right: rem(30px);
        }
    }
</style>
